import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 10.16V7.999a.667.667 0 0 1 1.333 0v2.133c0 .571 0 .96.025 1.26.024.292.068.441.12.545.128.251.332.455.583.583.105.053.254.097.546.12.3.025.689.025 1.26.025h4.266c.571 0 .96 0 1.26-.025.292-.024.441-.067.546-.12.25-.128.454-.332.582-.583.053-.104.097-.253.12-.546.025-.3.026-.688.026-1.259V7.999a.667.667 0 1 1 1.333 0v2.16c0 .537 0 .98-.03 1.34-.03.376-.096.72-.26 1.044-.256.501-.664.91-1.166 1.165-.324.165-.668.23-1.043.261-.36.03-.803.03-1.34.03H5.839c-.537 0-.98 0-1.34-.03-.375-.03-.72-.096-1.043-.261a2.67 2.67 0 0 1-1.165-1.165c-.165-.324-.23-.668-.262-1.043C2 11.14 2 10.696 2 10.16",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.47 5.138a.667.667 0 1 1-.943-.943l2-2c.26-.26.683-.26.943 0l2 2a.667.667 0 1 1-.943.943l-.862-.862V10a.667.667 0 1 1-1.333 0V4.276z"
    }, null, -1)
  ]))]))
}
export default { render: render }